/* Native radios and CSS handle every selection. JavaScript adds finite motion only. */
(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-journal-methods]:not([data-motion-ready])').forEach(root => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let motion;
    root.addEventListener('change', event => {
      if (!event.target.matches('.j-journal-methods__radio')) return;
      motion?.cancel();
      const art = root.querySelector(`#${CSS.escape(event.target.getAttribute('aria-controls'))} .j-journal-methods__art`);
      if (art && !reduced.matches) motion = art.animate(
        [{opacity: .5, transform: 'translateY(8px)'}, {opacity: 1, transform: 'none'}],
        {duration: 380, easing: 'ease-out'}
      );
    });
    reduced.addEventListener('change', () => { if (reduced.matches) motion?.cancel(); });
    root.dataset.motionReady = 'true';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
